module.exports = __webpack_public_path__ + "static/media/logomarca.91c54b59.png";